import Vue from 'vue';
import store from '../../lib/store';
import ScoreSetConfiguration from './components/ScoreSetConfiguration';

export default function () {
  const scoreSetEl = document.getElementById('score-set-configuration');

  if (scoreSetEl) {
    const scoreSetConfiguration = new Vue({
      el: scoreSetEl,
      components: {
        ScoreSetConfiguration
      },
      store
    });

    $(document).one('pjax:end', () => {
      scoreSetConfiguration.$destroy();
    });
  }
};
